import { STORAGE, API_ENDPOINT } from "../../constants";
import { HTTP } from "../http";
import { StorageService } from "../storage";

export const RemindersService = {
  save: (data: {
    period: string,
    name: string,
    date: string,
    comments: string
  }) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}operation/reminders`, {
      ...data,
      account,
    });
  },
  list: (period: string) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}operation/reminders/${account}/${period}`);
  },
};
